(() => {
  const policyAccountLoginUrl = document.body.dataset.xfunAccountLoginUrl;
  if (policyAccountLoginUrl) {
    document.querySelectorAll('.shopify-policy__body a[href="https://account.x-fun.shop"], .shopify-policy__body a[href="https://account.x-fun.shop/"]').forEach(link => {
      link.setAttribute('href', policyAccountLoginUrl);
    });
  }
  const groups = Array.from(document.querySelectorAll('[data-xfl-nav-group]'));
  groups.forEach(group => {
    group.addEventListener('toggle', () => {
      if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
    });
    group.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !group.open) return;
      event.preventDefault();
      group.open = false;
      group.querySelector('summary')?.focus();
    });
    group.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!group.contains(document.activeElement)) group.open = false;
      });
    });
  });
  document.addEventListener('click', event => {
    groups.forEach(group => {
      if (group.open && !group.contains(event.target)) group.open = false;
    });
  });
  const prefetchedProducts = new Map();
  function prefetchProductIntent(event) {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection && (connection.saveData || /^(slow-2g|2g|3g)$/.test(connection.effectiveType || ''))) return;
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || link.hasAttribute('download') || link.target && link.target !== '_self' || link.matches('.xfr-product-color__swatch')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/(?:^|\/)products\/[^/]+\/?$/.test(url.pathname) || url.pathname === location.pathname && url.search === location.search) return;
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview && !url.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', preview);
    url.hash = '';
    const existing = prefetchedProducts.get(url.href);
    if (existing && Date.now() - existing.time < 60000) return;
    if (existing) { existing.node.remove(); prefetchedProducts.delete(url.href); }
    const hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.as = 'document';
    hint.href = url.href;
    hint.fetchPriority = 'low';
    prefetchedProducts.set(url.href, {node:hint, time:Date.now()});
    document.head.appendChild(hint);
    while (prefetchedProducts.size > 6) {
      const oldest = prefetchedProducts.keys().next().value;
      prefetchedProducts.get(oldest).node.remove();
      prefetchedProducts.delete(oldest);
    }
  }
  document.addEventListener('pointerover', prefetchProductIntent, {passive:true});
  document.addEventListener('focusin', prefetchProductIntent);
  document.addEventListener('touchstart', prefetchProductIntent, {passive:true});
})();
